import React from 'react';

import Evento from '../components/evento.component';
import Layout from '../components/layout.component';
import { impulsaUrl, mainDescription } from '../data/main.data';
import eventos2026 from '../data/eventos2026.data';
import cartaz2026 from '../images/cartaz2026.webp';
import cartazImpulsa2026 from '../images/cartaz_impulsa2026.webp';
import logoCarbonoNeutro from '../images/logo_carbono_neutro.webp';
import mplatasPhoto from '../images/xurados/mplatas.webp';
import flavioMachadoPhoto from '../images/xurados/flaviomachado.webp';
import luisBaraPhoto from '../images/xurados/luisbara.webp';
import logos2026 from '../images/logos2026.webp';

const SUBTITLE = '22 ao 24 de outubro de 2026 · Vigo';

const getEventoDate = (evento) => {
  const { data, hora } = evento;
  const date = new Date(data);
  date.setHours(hora.split(':')[0]);
  date.setMinutes(hora.split(':')[1]);
  return (
    new Intl.DateTimeFormat('pt-PT', {
      day: 'numeric',
      month: 'long',
    }).format(date) +
    ' — ' +
    hora
  );
};

const IndexPage = () => {
  const navItems = [
    ...eventos2026.map((evento) => ({
      href: `#${evento.id}`,
      label: getEventoDate(evento),
      title: evento.bloque,
    })),
    {
      href: '#impulsa',
      label: 'Impulsa Cine',
      title: 'Impulsa Cine 2026',
    },
  ];

  return (
    <Layout
      subtitle={SUBTITLE}
      navItems={navItems}
      logos={logos2026}
      shareImage={cartaz2026}
    >
      <section className="presentacion">
        <div className="left">
          <h4>PONTES: cinema para atravesar fronteiras</h4>
          <p>
            Chegamos á 6ª edición de Pontes – Semana do Cinema Galego e
            Portugués, atravesando mares e océanos e creando, literalmente,
            pontes entre culturas, pobos, olladas e formas de resistencia.
          </p>
          <p>
            Pontes nace da experiencia de Abella Producións na organización de
            máis de 15 edicións de festivais e mostras de cinema e é a
            continuidade da antiga mostra Ponte Coa Lusofonía, celebrada durante
            catro anos consecutivos na cidade de Vigo. O cambio de nome responde
            á vontade de ampliar o proxecto e consolidalo como un espazo de
            encontro para o cinema galego e para as cinematografías dos países
            de lingua portuguesa e os seus idiomas orixinarios.
          </p>
          <p>
            O que levamos a Vigo son moito máis ca películas. Levamos novas
            narrativas, outras formas de mirar o mundo e unha ollada atenta
            sobre realidades que, a pesar da proximidade xeográfica e cultural,
            moitas veces permanecen afastadas de nós.
          </p>
          <p>
            A través do cinema podemos descubrir canto nos separa de África, a
            pesar de estarmos tan próximos xeograficamente, pero tamén canto
            temos en común. O Brasil e os países africanos de lingua portuguesa
            posúen, ademais, unha enorme diversidade lingüística e cultural que
            cada vez ten máis presenza nas súas cinematografías. Por iso, Pontes
            dá tamén espazo a películas faladas en linguas orixinarias, crioulas
            e outras linguas que forman parte da diversidade cultural destes
            territorios.
          </p>
          <p>
            Nun momento convulso e complexo como o que estamos a vivir, cómpre
            ampliar a mirada máis alá das nosas fronteiras e barreiras, abrir
            espazos para o encontro e crear novas posibilidades, novos diálogos
            e novos afectos.
          </p>
          <p>
            Por iso, Pontes non é só unha mostra de cinema. É tamén un espazo
            para o diálogo, a formación, a reflexión e a cooperación. A través
            de Impulsa Cine, celebramos unha masterclass e unha mesa de debate
            con profesionais e realizadores de Galicia, Brasil e Mozambique,
            abordando cuestións relacionadas coa creación, a industria
            audiovisual, a cooperación e os novos camiños do cinema.
          </p>
          <p>
            Desde Abella Producións cremos firmemente na consolidación destas
            redes. Queremos potenciar as posibilidades e oportunidades que poden
            xurdir a ambos os lados do Atlántico e contribuír a consolidar
            Galicia, e especialmente Vigo, como unha porta de entrada e un punto
            de encontro para estas cinematografías.
          </p>
          <p>
            Nesta sexta edición contamos con películas de Galicia, Brasil,
            Portugal, Cabo Verde, Mozambique, Angola, Guinea-Bissau e São Tomé e
            Príncipe. Fixemos unha coidada selección que achega a Galicia estreas
            nacionais e internacionais, con especial destaque para a estrea en
            España da película seleccionada por Portugal para representar o país
            nos Óscar.
          </p>
          <p>
            Seis edicións despois, Pontes continúa medrando coa mesma vontade
            coa que naceu: crear pontes culturais a través do cinema e achegar o
            público galego ás novas narrativas que están a transformar o
            audiovisual nos países de lingua portuguesa.
          </p>
          <p>
            Porque o cinema tamén é unha forma de viaxar, de coñecer outras
            realidades e de recoñecernos nelas.
          </p>
          <p>
            Esperamos que desfrutedes da programación e que estas Pontes
            continúen medrando, atravesando fronteiras e achegándonos.
          </p>
        </div>
        <div className="right">
          <img src={cartaz2026} alt={mainDescription} />
        </div>
      </section>
      <section className="edicion">
        <h3>Edición 2026</h3>
      </section>
      <section id="sedes" className="sedes">
        <h3>Sedes</h3>
        <div className="sedes-container">
          <div className="sede">
            <h4>Museo MARCO</h4>
            <p>Curtametraxes · 17:30 · de balde</p>
            <p>Rúa Príncipe, 54</p>
            <p>
              <a
                href="https://www.marcovigo.com/"
                target="_blank"
                rel="noreferrer"
              >
                www.marcovigo.com
              </a>
            </p>
          </div>
          <div className="sede">
            <h4>Multicines Norte</h4>
            <p>Longametraxes · 20:00 · 4&#8239;€</p>
            <p>Rúa Vía Norte, 22</p>
            <p>
              <a
                href="https://multicinesnorte.eu/"
                target="_blank"
                rel="noreferrer"
              >
                multicinesnorte.eu
              </a>
            </p>
          </div>
        </div>
      </section>
      <section className="eventos">
        {eventos2026.map((evento) => (
          <Evento key={evento.id} evento={evento} />
        ))}
      </section>
      <section id="impulsa" className="impulsa">
        <h3>Impulsa Cine</h3>
        <div className="impulsa-container">
          <div className="impulsa-text">
            <h4>Cinema, cultura e territorio desde as periferias</h4>
            <p>
              No marco de Impulsa Cine 2026, Abella Producións organiza unha
              xornada de reflexión e diálogo sobre o cinema contemporáneo, as
              políticas culturais e o desenvolvemento das industrias culturais
              desde unha perspectiva periférica, con experiencias de Brasil,
              Mozambique e Galicia.
            </p>
            <p>
              A programación inclúe a masterclass O cinema de vangarda brasileiro
              é periférico, a cargo de Igor Barradas e Luisa Godoy Pitanga, e a
              mesa de debate Cultura, territorio e industrias culturais desde as
              periferias, que reunirá profesionais e representantes de
              iniciativas culturais do Brasil, Mozambique e Galicia, para
              compartir experiencias e analizar os desafíos da creación
              artística, as políticas públicas e a cooperación cultural entre
              territorios.
            </p>
            <p>
              A xornada pretende fortalecer as redes de colaboración entre
              Galicia, Brasil e Mozambique, promovendo o intercambio de
              coñecementos, a reflexión sobre as políticas culturais e o impulso
              de novas oportunidades para as industrias culturais e creativas. A
              través do cinema e do diálogo entre experiencias periféricas,
              Impulsa Cine 2026 reivindica a cultura como ferramenta de
              transformación social, cohesión territorial e cooperación
              internacional.
            </p>
            <p>
              <strong>
                Mércores, 21 de outubro de 2026, de 17:30 a 21:00 h · Biblioteca
                da EMAO, Rúa García Barbón, 5, Vigo
              </strong>
            </p>
            <div className="download-container">
              <a
                href={impulsaUrl}
                className="download"
                target="_blank"
                rel="noreferrer"
              >
                impulsa.abella.gal
              </a>
            </div>
          </div>
          <div className="impulsa-cartaz">
            <a href={impulsaUrl} target="_blank" rel="noreferrer">
              <img
                src={cartazImpulsa2026}
                alt="Impulsa Cine – Encontro de Redes Galegas e Lusófonas de Cinema"
              />
            </a>
          </div>
        </div>
      </section>
      <section id="xurado" className="xurados">
        <h3>Xurado</h3>
        <div className="xurados-container">
          <div className="xurado">
            <img src={mplatasPhoto} alt="María Platas" />
            <h4>María Platas</h4>
            <p>
              Doutorada en Estudos Ingleses Avanzados cunha tese sobre o biopic
              como xénero empoderador no cinema feminista afroamericano, María
              Platas participa no grupo de investigación BiFeGa (Universidade de
              Vigo) e está asociada ao CISPAC. Actualmente, traballa como
              Profesora Axudante Doutora no Departamento de Filoloxía Inglesa,
              Francesa e Alemá da Universidade de Vigo.
            </p>
          </div>
          <div className="xurado">
            <img src={flavioMachadoPhoto} alt="Flávio Machado" />
            <h4>Flávio Machado</h4>
            <p>
              Á cabeza da Benguela Producións e Eventos Culturais, desenvolve e
              realiza festivais, mostras e proxectos de difusión cinematográfica,
              con actuación na curadoria, formación de público e promoción da
              diversidade da produción audiovisual brasileira e internacional.
              É idealizador e produtor do Baixada Animada – Festival
              Ibero-americano de Cinema de Animación, do VER CINE – Festival de
              Cinema da Baixada Fluminense e do FINTCH – Festival Internacional
              de Cinema de Humor.
            </p>
          </div>
          <div className="xurado">
            <img src={luisBaraPhoto} alt="Luís Bará" />
            <h4>Luís Bará</h4>
            <p>
              De ascendencia luso-galaica. Entre moitos oficios, fotógrafo de
              prensa, membro fundador do Cineclube Celta en Vigo e membro do
              xurado do Festival Internacional de Cinema da Figueira da Foz de
              1987 (Portugal).
            </p>
          </div>
        </div>
      </section>
      <section className="carbono-neutro">
        <h3>Evento carbono neutro</h3>
        <div className="carbono-neutro-container">
          <div className="carbono-neutro-text">
            <p>
              PONTES – Semana do Cinema Galego e Portugués será un evento carbono
              neutro, incorporando criterios de sustentabilidade e
              responsabilidade ambiental na súa organización.
            </p>
            <p>
              O festival contará co Selo PRIMA de Conciencia Climática, promovido
              por PRIMA – Mata Atlântica e Sustentabilidade, que permite
              cuantificar e compensar as emisións de gases de efecto invernadoiro
              asociadas á realización do evento.
            </p>
            <p>
              A compensación das emisións realizarase mediante o plantado de
              árbores nativas na Mata Atlántica brasileira, contribuíndo á
              recuperación e conservación dos ecosistemas, á protección da
              biodiversidade e á mitigación do cambio climático.
            </p>
            <p>
              Con esta iniciativa, PONTES incorpora a sustentabilidade como un
              dos eixes da súa responsabilidade cultural e social, promovendo
              prácticas máis respectuosas co medio ambiente e reforzando, ao
              mesmo tempo, a cooperación entre Galicia e Brasil.
            </p>
          </div>
          <div className="carbono-neutro-logo">
            <img src={logoCarbonoNeutro} alt="Selo PRIMA de Conciencia Climática" />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default IndexPage;
